// @flow

import _ from 'lodash';
import I18n from '../i18n/I18n';

export default class Notify {

  static error(title, message = '', callback = null) {
    bootbox.alert({
      title,
      message,
      buttons: {
        ok: {
          label: 'Ok',
          className: 'btn-danger'
        }
      },
      callback
    });
  }

  static alert(message, callback = null) {
    bootbox.alert({
      title: 'Attention',
      message,
      buttons: {
        ok: {
          label: 'Ok',
          className: 'btn-primary'
        }
      },
      callback
    });
  }

  static confirmDelete(message, callback) {
    bootbox.confirm({
      message,
      buttons: {
        cancel: {
          label: I18n.tr('global.cancel')
        },
        confirm: {
          label: I18n.tr('global.delete'),
          className: 'btn-danger'
        }
      },
      callback
    });
  }

  static confirmDeleteWithTitle(title, message, callback) {
    bootbox.confirm({
      title,
      message,
      buttons: {
        cancel: {
          label: I18n.tr('global.cancel')
        },
        confirm: {
          label: I18n.tr('global.delete'),
          className: 'btn-danger'
        }
      },
      callback
    });
  }

  static confirmDeleteWithContent(title, message, callback) {
    bootbox.confirm({
      title,
      message: _.isEmpty(message) ? ' ' : message,
      buttons: {
        cancel: {
          label: I18n.tr('global.cancel')
        },
        confirm: {
          label: I18n.tr('global.delete'),
          className: 'btn-danger'
        }
      },
      callback
    });
  }

  static confirm(message, callback) {
    bootbox.confirm({
      message,
      buttons: {
        cancel: {
          label: I18n.tr('global.cancel')
        },
        confirm: {
          label: I18n.tr('global.confirm'),
          className: 'btn-primary'
        }
      },
      callback
    });
  }

  static message(message, callback) {
    bootbox.alert({
      message,
      buttons: {
        ok: {
          label: 'Ok',
          className: 'btn-primary'
        }
      },
      callback
    });
  }

  static messageWithTitle(title, message, callback) {
    bootbox.alert({
      title,
      message,
      buttons: {
        ok: {
          label: 'Ok',
          className: 'btn-primary'
        }
      },
      callback
    });
  }

  static prompt(title, callback) {
    bootbox.prompt({
      title,
      callback,
      buttons: {
        cancel: {
          label: I18n.tr('global.cancel')
        },
        confirm: {
          label: 'Ok',
          className: 'btn-primary'
        }
      }
    });
  }

  static promptWithValue(title, value, callback) {
    bootbox.prompt({
      title,
      value,
      callback,
      buttons: {
        cancel: {
          label: I18n.tr('global.cancel')
        },
        confirm: {
          label: 'Ok',
          className: 'btn-primary'
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/utils/Notify.js